export default function (data) {
  return _.isArray(data) ? data : [data];
}



// WEBPACK FOOTER //
// ./src/transport/utils/cast-aray.js